module.exports = __webpack_public_path__ + "img/linkedIn_logo.a2a4fcfd.svg";